module.exports = __webpack_public_path__ + "static/media/icon_add_circle.2fb97566.png";